import type { Report, VorankuendigungData } from '../../types';

/**
 * Der Autospeicher der Vorankuendigung — als reine Funktion, damit pruefbar
 * ist, AUF WELCHEM STAND er schreibt.
 *
 * Der Timer feuert zwei Sekunden nach der letzten Eingabe. Bis dahin kann
 * sich der Bericht geaendert haben, ohne dass sich `data` aenderte: der
 * Abschlussschritt nach dem Versand bucht eine Paketposition (`BST-…`,
 * Plan Bestandteile B5) ueber `onUpdate`. Schrieb der Timer mit dem `report`
 * aus der Closure seines Renders, setzte er diese Buchung still zurueck —
 * `App.handleUpdateReport` ersetzt, es wird nichts gemergt. Dieselbe Falle
 * wie im Autospeicher der Unterlage (UnterlageView, `reportRef`).
 *
 * Deshalb: geschrieben wird auf den Bericht, der beim FEUERN gilt
 * (`aktuell`), und nur die Vorankuendigung wird ersetzt. `null` = nichts zu
 * schreiben (Inhalt unveraendert).
 */
export const vorankAutospeicherStand = (aktuell: Report, data: VorankuendigungData): Report | null =>
    JSON.stringify(aktuell.vorankuendigung) === JSON.stringify(data) ? null : { ...aktuell, vorankuendigung: data };
